import { render, staticRenderFns } from "./Survey.vue?vue&type=template&id=66a0be62&scoped=true"
import script from "./Survey.vue?vue&type=script&lang=js"
export * from "./Survey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a0be62",
  null
  
)

export default component.exports